module.exports = __webpack_public_path__ + "img/dcmm_14.34288b8d.png";